// removed by extract-text-webpack-plugin
module.exports = {"Container":"faq__Container__s0jGe","BackgroundContainer":"faq__BackgroundContainer__19myq","Background":"faq__Background__C-Cuy","Tagline":"faq__Tagline__3Gsrn","Banner":"faq__Banner__2fxh9","Sup":"faq__Sup__2iDbV","Image":"faq__Image__2-KjY","Content":"faq__Content__2r3vL","Description":"faq__Description__2lnFP","Link":"faq__Link__zhz1S","Links":"faq__Links__1rptO faq__Link__zhz1S"};


//////////////////
// WEBPACK FOOTER
// ./src/Layout/Faq/faq.css
// module id = 1246
// module chunks = 2